import { CheckBoxSharp, SquareSharp } from "@mui/icons-material";
import { Checkbox as MuiCheckbox, CheckboxProps } from "@mui/material";
import { ReactElement } from "react";

export const Checkbox = (props: CheckboxProps): ReactElement => {
  return (
    <MuiCheckbox
      checkedIcon={<CheckBoxSharp />}
      icon={<SquareSharp />}
      {...props}
    />
  );
};
